import logo from './logo.svg';
import './App.css';
import Doubt from './Doubt';

function App() {
  return (
    <Doubt/>
  );
}

export default App;
